import { Dispatch, SetStateAction, useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { OverdriveTracking } from './overdrive-tracking';

const tenYearsInMilliseconds = 365 * 24 * 60 * 60 * 1000 * 10;

export const useOverdriveTracking = (
    cookieDomain?: string,
    isGdprCountry?: boolean
): [
    () => void,
    boolean,
    Dispatch<SetStateAction<boolean>>,
    boolean,
    Dispatch<SetStateAction<boolean>>
] => {
    const [cookies, setCookie] = useCookies(['od_track']);
    const [analyticsTrackingEnabled, setAnalyticsTrackingEnabled] =
        useState(false);
    const [performanceTrackingEnabled, setPerformanceTrackingEnabled] =
        useState(false);

    useEffect(() => {
        const overdriveTracking = new OverdriveTracking(
            cookies.od_track,
            isGdprCountry
        );
        setAnalyticsTrackingEnabled(overdriveTracking.analyticsTrackingEnabled);
        setPerformanceTrackingEnabled(
            overdriveTracking.performanceTrackingEnabled
        );
    }, [cookies, isGdprCountry]);

    const updateTracking = () => {
        const overdriveTracking = new OverdriveTracking(
            cookies.od_track,
            isGdprCountry
        );
        overdriveTracking.analyticsTrackingEnabled = analyticsTrackingEnabled;
        overdriveTracking.performanceTrackingEnabled =
            performanceTrackingEnabled;

        setCookie('od_track', overdriveTracking.flags, {
            domain:
                cookieDomain ??
                (window.OverDrive?.isLocal
                    ? window.location.hostname
                    : 'overdrive.com'),
            path: '/',
            expires: new Date(Date.now() + tenYearsInMilliseconds),
            sameSite: 'lax',
            secure: true,
        });
    };

    return [
        updateTracking,
        analyticsTrackingEnabled,
        setAnalyticsTrackingEnabled,
        performanceTrackingEnabled,
        setPerformanceTrackingEnabled,
    ];
};
